import { useEffect, useMemo, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import SVG from "react-inlinesvg";
import * as actions from "../../../../_redux/school-reports/SchoolReportsAction";
import { nonPositiveModuleOrderAlert, noRecordsAlert, resultAlert } from "../../../../../../../_helpers/Helpers";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";
import { 
  Card, 
  CardBody, 
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar
} from "../../../../../../../_metronic/_partials/controls";
import { useSchoolReportModulesUIContext } from "./SchoolReportModulesUIContext";
import { SchoolReportModulesFilter } from "./school-report-modules-filter/SchoolReportModulesFilter";
import { SchoolReportModulesTable } from "./school-report-modules-table/SchoolReportModulesTable";

export function SchoolReportModulesCard({
  reportId,
  goNext
}) {
  // School Report Modules UI Context
  const schoolReportModulesUIContext = useSchoolReportModulesUIContext();
  const schoolReportModulesUIProps = useMemo(() => {
    return {
      ids: schoolReportModulesUIContext.ids
    };
  }, [schoolReportModulesUIContext]);
    
  // Getting curret state of School Report list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.schoolReports }),
    shallowEqual
  );
  const { actionsLoading, modules } = currentState;

  // School Reports Redux state
  const dispatch = useDispatch();

  const [moduleValues, setModuleValues] = useState();

  useEffect(() => {
    setModuleValues(modules);
  }, [modules]);

  /** Belli Bir Okul Karnesine Ait Modül Listesini Kaydeder */
  const saveModules = (moduleValues) => {
    if (schoolReportModulesUIProps.ids.length < 1) {
      noRecordsAlert();
      return; 
    }
    const selectedModules = moduleValues.filter(module => schoolReportModulesUIProps.ids.includes(module.id));

    if (schoolReportModulesUIProps.ids.length > selectedModules.length) {
      nonPositiveModuleOrderAlert();
      return;
    }    
    dispatch(actions.saveModules(reportId, selectedModules)).then(result => onResult(result));
  }

  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => goNext(), 2500);
  };

  const title = <>Karne Modülleri{schoolReportModulesUIProps.ids.length > 0 ?
                  <> [Seçilen Kayıt Sayısı: <span style={{color:"red"}}>{schoolReportModulesUIProps.ids.length}</span>]</> : ""}
                </>;

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => saveModules(moduleValues)}
          >
            Kaydet ve İlerle
            <span className="svg-icon svg-icon-md ml-1">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Arrow-right.svg")} />
            </span>
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <SchoolReportModulesFilter />
        <SchoolReportModulesTable
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
      </CardBody>
    </Card>
  );
}